export default __webpack_public_path__ + "images/b7aaca765be9bfe3028ff35b90d692e8.svg";